/**
 * @description - This functions is used in Playbooklist component,
 * to filter out playbooks for newRisk and specific resource or risk
 * @param {Object[]} playbooksList - list of playbooks
 * @param {String} signature - signature Id 
 * @param {*} resource - resoruce Id
 * @returns {Object[]} - Filtered playbooks
 */
export const getFilteredPlaybooks = (playbooksList, cloudAccounts, signature, resource, service) => {

    return playbooksList.filter(playbook => (

        playbook.triggerInfo.type === "newRisk" &&
        isPlaybookIncludesSignatureOrResource(playbook, signature, resource) &&
        isPlaybookIncludesCloudAccounts(playbook, cloudAccounts) &&
        isPlaybookIncludesService(playbook, service)

    ));

}

/**
 * @description - This is a helper function for getFilteredPlaybooks()
 * @summary - It is used to check a specific playbook is of currently selected resource or risk.
 * @param {Object} playbook - playbook data
 * @param {String} signature - signature Id
 * @param {String} resource - resource Id
 * @returns 
 */
const isPlaybookIncludesSignatureOrResource = (playbook, signature, resource) => {

    if (signature) {

        let signatures = playbook?.triggerInfo?.alert?.signatures;

        if (Array.isArray(signatures)) {
            return signatures.includes(signature);
        }

        return signatures === signature;
    }

    let resources = playbook?.triggerInfo?.alert?.resources;

    if (Array.isArray(resources)) {
        return resources.includes(resource);
    }

    return resources === resource;

}

/**
 * @description - This is a helper function for getFilteredPlaybooks()
 * @summary - It is used to check a specific playbook is of currently selected service.
 * @param {String} service - service id
 * @returns 
 */
const isPlaybookIncludesService = (playbook, service) => {

    let services = playbook?.triggerInfo?.alert?.services;

    if (Array.isArray(services)) {
        return services.includes(service);
    }

    return services === service;

}

/**
 * @description - This is a helper function for getFilteredPlaybooks()
 * @summary - It is used to check if playbook includes any of the selected cloud accounts.
 * @param {Object} playbook - playbook data
 * @param {Object[]} cloudAccounts - selected cloud accounts
 * @returns 
 */
const isPlaybookIncludesCloudAccounts = (playbook, cloudAccounts) => {

    // If no cloud account is selected, then pass this check
    if (cloudAccounts.length === 0) {
        return true;
    }

    let playbookCloudAccountsIds = playbook?.triggerInfo?.alert?.cloudAccounts;

    // Select playbook if it includes any of the selected cloud accounts
    return cloudAccounts.some(cloudAccount => playbookCloudAccountsIds.includes(cloudAccount.id))
}

/**
 * @description - This functions is used to get dynamic description for resource or risk in Remediation tab 
 * @param {String} signature 
 * @returns {String}
 */
export const getDescription = (signature) => {
    return signature ?
        ' Create automated workflows to remediate risks using Cloudnosys Playbooks feature. A playbook can help automate and orchestrate your response and will run automatically as soon as this risk gets detected.'
        :
        ' Create automated workflows to remediate resources using Cloudnosys Playbooks feature. A playbook can help automate and orchestrate your response whenever a new risk is detected for this resource.';
}